import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EparcoursPath } from '../../constantes/menu/menu-items/eparcours-path';
import { NavService } from './nav-service';
import { PARAM_TOKEN } from './navigators/navigators';

@Injectable({
  providedIn: 'root',
})
export class DossiersFinancementNavService extends NavService {
  constructor(protected router: Router) {
    super(router);
  }

  liste = this.makeNavigator(EparcoursPath.root.DOSSIERS_FINANCEMENT, EparcoursPath.dossiersFinancement.LISTE);



  creation_contrat = this.makeNavigatorWithParam(
    EparcoursPath.root.DOSSIERS_FINANCEMENT,
    EparcoursPath.dossiersFinancement.CREATION_CONTRAT,
    PARAM_TOKEN
  );

  creation_contrat_session = this.makeNavigatorWith2Params(
    EparcoursPath.root.DOSSIERS_FINANCEMENT,
    EparcoursPath.dossiersFinancement.CREATION_CONTRAT_SESSION,
    PARAM_TOKEN,
    PARAM_TOKEN
  )

  edition_contrat = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.DOSSIERS_FINANCEMENT,
    EparcoursPath.dossiersFinancement.EDITION,
    PARAM_TOKEN,
    EparcoursPath.dossiersFinancement.GENERAL_CONTRAT,
  );

  edition_contrat_session = this.makeNavigatorWith2Params<number, number>(
    EparcoursPath.root.DOSSIERS_FINANCEMENT,
    EparcoursPath.dossiersFinancement.EDITION,
    PARAM_TOKEN,
    EparcoursPath.dossiersFinancement.GENERAL_CONTRAT_SESSION,
    PARAM_TOKEN
  )

  financements = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.DOSSIERS_FINANCEMENT,
    EparcoursPath.dossiersFinancement.EDITION,
    PARAM_TOKEN,
    EparcoursPath.dossiersFinancement.FINANCEMENTS,
  );

  edition_facture = this.makeNavigatorWith2Params<number, number>(
    EparcoursPath.root.DOSSIERS_FINANCEMENT,
    EparcoursPath.dossiersFinancement.EDITION,
    PARAM_TOKEN,
    EparcoursPath.dossiersFinancement.FINANCEMENTS,
    EparcoursPath.dossiersFinancement.EDITION_FACTURE,
    PARAM_TOKEN
  );

  documents = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.DOSSIERS_FINANCEMENT,
    EparcoursPath.dossiersFinancement.EDITION,
    PARAM_TOKEN,
    EparcoursPath.dossiersFinancement.DOCUMENTS
  )

  inscriptions = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.DOSSIERS_FINANCEMENT,
    EparcoursPath.dossiersFinancement.EDITION,
    PARAM_TOKEN,
    EparcoursPath.dossiersFinancement.INSCRIPTIONS,
  );
}
